export default [
  {
    //  全能神显现作工主要话语发表纪实
    path: "/the-word-appears-in-the-flesh",
    name: "the-word-appears-in-the-flesh",
    component: () => import("@/views/the-word-appears-in-the-flesh/index.vue"),
    meta: {
      title: "全能神显现作工主要话语发表纪实",
      order: 20,
      episode: "episode6",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/the-word-appears-in-the-flesh/bg.jpg",
          "images/the-word-appears-in-the-flesh/bg-front.png",
        ],
      },
    },
  },
];
